import type { JSX } from "react";
import { useEffect, useRef } from "react";
import { Html } from "@react-three/drei";
import * as THREE from "three";
import { useSceneStore } from "@/state/useSceneStore";
import { useTimeOfDay } from "@/hooks/useTimeOfDay";
import { mugMessage } from "@/scene/objects/mugMessage";

const AUTO_HIDE_MS = 4000;

export const Mug = (): JSX.Element | null => {
  const mesh = useSceneStore((s) => s.objects.mug);
  const blurbOpen = useSceneStore((s) => s.mugBlurbOpen);
  const toggleMugBlurb = useSceneStore((s) => s.toggleMugBlurb);
  const { band } = useTimeOfDay();
  const autoHide = useRef<number | null>(null);

  useEffect(() => {
    if (!blurbOpen) {
      if (autoHide.current !== null) {
        window.clearTimeout(autoHide.current);
        autoHide.current = null;
      }
      return;
    }
    autoHide.current = window.setTimeout(() => {
      toggleMugBlurb();
      autoHide.current = null;
    }, AUTO_HIDE_MS);
    return () => {
      if (autoHide.current !== null) {
        window.clearTimeout(autoHide.current);
        autoHide.current = null;
      }
    };
  }, [blurbOpen, toggleMugBlurb]);

  if (!mesh || !blurbOpen) return null;

  const worldPos = new THREE.Vector3();
  mesh.getWorldPosition(worldPos);
  worldPos.y += 0.4;

  return (
    <Html position={[worldPos.x, worldPos.y, worldPos.z]} zIndexRange={[10, 0]}>
      <div className="pointer-events-none -translate-x-1/2 -translate-y-full rounded-sm border border-phosphor bg-bg1/90 px-3 py-2 font-mono text-xs text-phosphor backdrop-blur-sm">
        <div className="uppercase tracking-wider text-ink2">caffeine</div>
        <div>{mugMessage(band)}</div>
      </div>
    </Html>
  );
};
